// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiParameter,
    get,
    HasPagingParameters,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { RequestTrailerPickupResponseModel, TrailerTrackingV2CollectionModel } from "@store/Framework/Types/ApiModels";

const baseUrl = "/api/v2/custom/droptrailer";

export interface GetTrailerTrackingsV2ApiParameter extends ApiParameter, HasPagingParameters {
    alertsOnly?: boolean;
    billingType?: string;
    customerSequence?: string;
    dwellTimeDays?: number;
    dwellTimeOperator?: "gt" | "lt" | "eq" | string;
    onSiteOnly?: boolean;
    plantCode?: string;
    poNumber?: string;
    trailerId?: string;
}

export interface RequestTrailerPickupApiParameter extends ApiParameter {
    shipToNumber: string;
    trailerId: string;
    shipmentNumber: string;
    pickupOption: "bobtail" | "next-delivery";
    requestedPickupDate?: Date;
    additionalNotes?: string;
}

export function getTrailerPickupRequestKey({
    shipToNumber,
    trailerId,
    shipmentNumber,
}: {
    shipToNumber: string;
    shipmentNumber: string;
    trailerId: string;
}) {
    return `${shipToNumber}-${trailerId}-${shipmentNumber}`;
}

export async function getTrailerTrackingsV2(
    parameter: GetTrailerTrackingsV2ApiParameter,
): Promise<ServiceResult<TrailerTrackingV2CollectionModel>> {
    try {
        const result = await get<TrailerTrackingV2CollectionModel>(baseUrl, parameter);

        return { successful: true, result };
    } catch (error) {
        return { successful: false, errorMessage: "" };
    }
}

export async function postRequestTrailerPickup(
    parameter: RequestTrailerPickupApiParameter,
): Promise<ServiceResult<RequestTrailerPickupResponseModel>> {
    try {
        const result = await post<RequestTrailerPickupApiParameter, RequestTrailerPickupResponseModel>(
            baseUrl + "/request-pickup",
            parameter,
        );

        return { successful: true, result };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error.errorJson.message,
        };
    }
}
